import React from "react"
import { Box, Modal, withStyles } from "@ridecell/web-components-material"
import { injectIntl } from "react-intl"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme } from "@material-ui/core/styles"

import AddPaymentMethod from "../../components/WebAppPortal/PaymentMethod"
import useGlobalContext from "../../utils/customHooks/useGlobalContext"
import styles from "./styles"
import messages from "./messages"

const PaymentModal = ({
  intl: { formatMessage },
  classes,
  closeModal,
  handleNext,
  openModal,
  returnUrl,
}) => {
  const {
    setError,
    state: { customer },
  } = useGlobalContext()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <Modal className={classes.modal} open={openModal}>
      <Box className={isMobile ? classes.mobilePaper : classes.paper}>
        <AddPaymentMethod
          customerId={customer.id}
          handleNext={handleNext}
          headerText={formatMessage(messages.addPaymentMethod)}
          onClose={closeModal}
          returnUrl={returnUrl}
          setError={setError}
        />
      </Box>
    </Modal>
  )
}

export default withStyles(styles)(injectIntl(PaymentModal))
